
import React from "react";

import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

export default function AddTextModal({ addNewImage, isOpenImageModal, closeImageModal }) {
// const handleImageChange = (e)=>{
//   addImageFile(e.target.files[0]);
//   closeImageModal();
// }

const getBase64 = file => {
    return new Promise(resolve => {
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};
const handleImageChange = async (e) => {
    var file = e.target.files[0];
    getBase64(file)
        .then(src => {
            file["base64"] = src;
            addNewImage(src);
            closeImageModal();
        })
        .catch(err => {
            console.log(err);
        });
    // var src = URL.createObjectURL(file);
}

  return (
    <div>
     
      <Dialog fullWidth open={isOpenImageModal} onClose={closeImageModal} aria-labelledby="form-dialog-title" maxWidth={`xs`} >
        <DialogTitle id="form-dialog-title" className="modal-title">Add New Image</DialogTitle>
        
        <DialogContent >
         <div className="addImage">
            <label for="addImage"><AddIcon /> Upload Image / Logo</label>
            <input type="file" id="addImage" onChange={handleImageChange} />
         </div>
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={closeImageModal} variant="contained" color="secondary">
            Close
          </Button>
        </DialogActions>
      
      </Dialog>
    </div>
  );
}
